export default "__VITE_ASSET__40cc21a9__"